var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoJt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "121px",
    height: "121px",
    viewBox: "-0.5 -0.5 121 121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 120,
    height: 120,
    rx: 18,
    ry: 18,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10,
    width: 110,
    height: 100,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 87,
    fill: "#FFD966",
    fontFamily: "Helvetica",
    fontSize: "80px",
    textAnchor: "middle",
    fontWeight: "bold"
  }, "JT"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoJt);
export default __webpack_public_path__ + "static/media/logoJT.e754beb586930147f93db80b14d9c2c1.svg";
export { ForwardRef as ReactComponent };